import React, { ComponentProps } from 'react';
import { ISonURL } from '../../../types/IUrl';
import { asView } from '../../../_lib/ViewFetcher';
import { useLayoutGroupContext } from '../../../components/blocks/LayoutGroup/LayoutGroup';
import { MediaInformation } from '../../../components/organisms/MediaInformation';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { IFrame, IFrameContainer } from '../../../_lib/components/IFrame';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { IFrameModifier } from '../../../_lib/components/IFrame/IFrame';

const getHostnameFromUrl = (url: string): string => {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
};

export type ExternalContentDefaultViewProps = {
  iframe: ISonURL & {
    title: string;
    caption?: string;
    size?: 'large' | 'medium' | 'small';
    orientation: 'portrait' | 'landscape';
    popUp?: boolean;
    popUpUrl?: string;
  };
};

function ExternalContentDefault({ iframe }: ExternalContentDefaultViewProps) {
  const groupLayout = useLayoutGroupContext();
  const { url, title, caption, size, popUp, orientation, popUpUrl } = iframe;
  const { t } = useSonTranslation('ExternalContent');
  const iFrameTitle = title || t('externalContentOfUrl', { url: getHostnameFromUrl(url) });

  const getModifier = (orientationPar: 'portrait' | 'landscape'): Modifier<IFrameModifier> | undefined => {
    if (orientationPar === 'portrait') {
      return IFrameModifier.PORTRAIT;
    }
    return undefined;
  };

  return (
    <MediaInformation
      media={{
        size,
        caption,
        contentType: 'iframe',
      }}
      hasPopUp={popUp}
      popUpContent={(
        <IFrameContainer>
          <IFrame title={iFrameTitle} src={popUp && popUpUrl ? popUpUrl : url} modifier={getModifier(orientation)} />
        </IFrameContainer>
      )}
      groupLayout={groupLayout}
    >
      <IFrameContainer modifier="no-padding">
        <IFrame title={iFrameTitle} src={url} modifier={getModifier(orientation)} />
      </IFrameContainer>
    </MediaInformation>
  );
}

export const ExternalContentDefaultView = asView(ExternalContentDefault);
export type ExternalContentDefaultView = ComponentProps<typeof ExternalContentDefaultView>;
